module.exports = __webpack_public_path__ + "static/media/defaultProductImg.a09d1a8f.png";